import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { translator } from 'mage-i18n';

import { Alert, MOET_CONSTANTS } from 'moet-core';

import copyToClipboard from '@/utils/copyToClipboard';
import { getWidgetTypeFromWidgetCookie } from '@/selectors/widget';

const { WIDGET_TYPE } = MOET_CONSTANTS;

const errorMessageStyle = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const isUnkownError = error => {
  const type = get(error, 'response.data.type', '');
  const errorCode = get(error, 'response.data.errorCode', '');

  return type === 'UnknownError' || (type === 'ErrorCodeError' && errorCode === 'UNKNOWN_ERROR');
};

const genericMessageForMerchant = ({ widgetType = '' }) => {
  let suffix = 'general';

  switch (widgetType) {
    case WIDGET_TYPE.MANAGED_RISK:
      suffix = 'salesforce';
      break;

    case WIDGET_TYPE.MANAGED_KYC:
    case WIDGET_TYPE.MANAGED_SME_KYC:
      suffix = 'managed_kyc';
      break;
  }
  return `products-fe.errors.${suffix}`;
};

const _ServerErrorAlert = ({ error, t, widgetType }) => {
  const errorMessageFromServer = get(error, 'response.data.message', '');
  const correlationId =
    get(error, 'response.headers.klarna-correlation-id', '') ||
    get(error, 'response.config.headers.Klarna-Correlation-Id', ''); // fallback to req. corr. id

  // Check whether the message received from the server is an error key
  const translatedMessageFromServer =
    errorMessageFromServer && t(`products-fe.error_messages.errors_keys.${errorMessageFromServer}`);

  // If it's not, fall back to generic message
  const genericMessage = genericMessageForMerchant({ widgetType });
  const errorMessageToShow = translatedMessageFromServer || t(genericMessage);

  const correlationIdMessage =
    correlationId &&
    t('products-fe.error_messages.errors_keys.correlationIdLabel', { correlationId });

  const messageText = isUnkownError(error) ? errorMessageFromServer : errorMessageToShow;

  const errorMessage = (
    <div style={errorMessageStyle}>
      {messageText}
      <br />
      {correlationIdMessage}
    </div>
  );

  return (
    <Alert
      type="error"
      content={errorMessage}
      linkText={t('products-fe.errors.copy')}
      onLinkClick={() => copyToClipboard(`${messageText}${correlationIdMessage}`)}
    />
  );
};

_ServerErrorAlert.propTypes = {
  error: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  widgetType: PropTypes.string.isRequired,
};

export const ServerErrorAlert = connect(state => ({
  t: translator(state),
  widgetType: getWidgetTypeFromWidgetCookie(state),
}))(_ServerErrorAlert);
